import ResourceFileUpload from "../../components/Resource/ResourceFileUpload";
import ResourceMetaSEO from "../../components/Resource/ResourceMetaSEO";
import { useEffect, useState, useRef } from "react";
import TiptapEditor from "../../components/Tiptap/TiptapEditor";
import { useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { connect, useDispatch } from "react-redux";
import Dropzone from "react-dropzone";
import ResourceTags from "../../components/Resource/ResourceTags";
// import { format } from "date-fns";

import { setMessage, setSuccessMessage } from "../../redux/actions/message";
import { history } from "../../redux/store";
import ResourceAPI from "../../api/resourceAPI";
import FileAPI from "../../api/fileAPI";
import ResourceFiles from "../../components/Resource/Files";
//import PreviewImage from "../../components/Resource/PreviewImage";
import AuthLayout from "../../components/AuthLayout/AuthLayout";
import RejectionReason from "../../data/rejection-reason.json";

import { MEDIA_URL } from "../../configs";
// import AWS from "aws-sdk";

// AWS.config.update({
//   accessKeyId: S3_KEY,
//   secretAccessKey: S3_SECRET
// });


function ResourceEdit(props) {
  const { id } = useParams();

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    watch,
    setFocus,
    formState: { errors }
  } = useForm({ mode: "onBlur" });
  const dispatch = useDispatch();
  const { message, messageType } = props;

  const [isLoading, setIsLoading] = useState(true);
  const [mainImage, setMainImage] = useState(0);
  const [selectedImage, setSelectedImage] = useState([]);
  const [resourceFiles, setResourceFiles] = useState([]);
  const [resource, setResource] = useState([]);
  const [newResourceFiles, setNewResourceFiles] = useState([]);

  // For Tiptap rich text editor (resource description)
  const [descriptionValue, setDescriptionValue] = useState("");

  //tags state data
  const [selectedTags, setSelectedTags] = useState([]);
  const [suggestedTags, setSuggestedTags] = useState([]);

  //meta seo state data
  const [showMeta, toggleShowMeta] = useState(false);
  const watchTitle = watch("meta_title", false);

  // progress state only for preview images, not resource files
  const watchDescription = watch("meta_description", false);
  const tempPreviewRef = useRef([]);
  const tempFilesRef = useRef([]);

  // const awsBucket = new AWS.S3({
  //   params: { Bucket: S3_BUCKET },
  //   region: S3_REGION
  // });

  //function slugify(str) {
  const slugify = async (event) => {
    let str = getValues("name");
    let slug_id = getValues("slug_id");
    // let today = Math.round((new Date()).getTime() / 1000);
    let slug = String(str + " " + slug_id).normalize("NFKD") // split accented characters into their base characters and diacritical marks
      .replace(/[\u0300-\u036f]/g, "") // remove all the accents, which happen to be all in the \u03xx UNICODE block.
      .trim() // trim leading or trailing whitespace
      .toLowerCase() // convert to lowercase
      .replace(/[^a-z0-9 -]/g, "") // remove non-alphanumeric characters
      .replace(/\s+/g, "-") // replace spaces with hyphens
      .replace(/-+/g, "-"); // remove consecutive hyphens
    setValue("slug", slug);
    event.preventDefault();
  };

  /**
   *
   * @param {string} tag
   */
  const fetchRelatedTags = async (tag) => {
    await ResourceAPI.getRelatedTag(tag).then((response) => {
      //add new tags to suggested tags
      setSuggestedTags((current) => [...current, ...response.data]);
    }).catch((e) => {
      dispatch(setMessage(`${e}`, "danger"));
    });
  };

  /**
   * Add tag
   * @param {array} tag
   */
  const handleTags = async (tag) => {
    //get new tag to get related
    let new_tag = tag.filter((x) => !selectedTags.includes(x));
    //process if paste value with (,)
    if (new_tag[0] && new_tag[0].split(",")) {
      //remove new_tag from tag
      tag.splice(tag.indexOf(new_tag), 1);
      //append splited value to tag
      let tmp = new_tag[0].split(",");
      tmp.map((element) => {
        //Add only none exist tag
        if (tag.indexOf(element) === -1) {
          tag.push(element);
          fetchRelatedTags(element);
        }
      });
    } else {
      //get related tag
      if (new_tag != "") {
        fetchRelatedTags(new_tag[0]);
      }
    }
    //set selected tag state
    setSelectedTags(tag);
    //process tags input value
    let tag_values = getValues("tags").split(",");

    tag.map((t) => {
      if (t !== "" && !tag_values.includes(t)) {
        //avoid adding empty value
        if (getValues("tags").length > 0) {
          tag_values.push(t);
        } else {
          tag_values = [t];
        }
      }
    });
    //set tags value
    setValue("tags", tag_values.join(","));
  };

  const { previewProcess, previewProgress, previewUploadError } =
    FileAPI.useUploadPreview();
  const { fileProcess, isLoading: fileUploading, fileUploadError } = FileAPI.useUploadFile();

  /**
   * Save resources data on submit form
   * @param {form} data
   */
  const onSubmit = async () => {
    setValue("description", descriptionValue);

    // Get the latest form values
    const formData = getValues();

    // Ensure price is a valid number for backend
    if (formData.license !== "premium" || formData.price === "" || formData.price === undefined || isNaN(formData.price)) {
      formData.price = 0;
    } else {
      formData.price = parseFloat(formData.price) || 0;
    }

    setIsLoading(true);

    let tagsData = [];
    let tagsArray = formData.tags ? formData.tags.split(",") : [];
    tagsArray.map((tag) => {
      tagsData.push({ name: tag });
    });
    formData.tags = tagsData;
    formData.creator = { email: formData.created_by };

    if (selectedImage.length > 0) {
      formData.images = selectedImage;
      formData.mainImage = mainImage;
    }

    try {
      await ResourceAPI.updateResource(resource._id, formData).then(() => {
        if (newResourceFiles.length) {
          
          Promise.all(
            newResourceFiles.map((file) => {
              let filename = file.filename.split(/[\\\/]/).pop();
              let file_ext = filename.split(".").pop();

              const fileData = {
                filename: filename,
                resourceId: resource._id,
                aws_path: file.aws_path ? file.aws_path : '',
                path: file.filepath ? file.filepath : '',
                format: file_ext,
                file_size: file.file_size
              };
              

              FileAPI.createResourceFile(fileData).then((res) => {
                // if (
                //   res?.data?.format === "ai" ||
                //   res?.data?.format === "eps"
                // ) {
                //   FileAPI.scanAiFile(res.data._id).then(() => {
                //   }).catch(() => {
                //     dispatch(
                //       setMessage(
                //         `Gen metadata file ${res.data._id} failed`,
                //         "danger"
                //       )
                //     );
                //   });
                // }
              }).catch(function(response) {
                dispatch(setMessage(response.message, "danger"));
              });
            })
          ).then(async () => {
            // After all files are created, trigger ContentType auto-detection
            try {
              await ResourceAPI.detectContentType(resource._id);
            } catch (err) {
              console.warn('Failed to auto-detect ContentType:', err);
            }
            dispatch(setSuccessMessage("Update successfully"));
          });
        } else {
          dispatch(setSuccessMessage("Update successfully"));
        }
      });
    } catch (e) {
      dispatch(setMessage(`${e}`, "danger"));
    }
    setIsLoading(false);
  };

  /**
   * Remove tag
   * @param {string} tag
   */
  const handleRemoveTag = (tag) => {
    // Remove the tag from selectedTags
    const updatedSelectedTags = selectedTags.filter((t) => t !== tag);
    setSelectedTags(updatedSelectedTags);

    // Update the tags value in the form
    setValue("tags", updatedSelectedTags.join(","));

    // Remove the tag from suggestedTags if it exists
    const updatedSuggestedTags = suggestedTags.filter((tg) => tg._id !== tag);
    setSuggestedTags(updatedSuggestedTags);
  };

  /**
   * add suggested tag to selected
   * @param {string} tag
   */
  const addSugggestTag = (tag) => {
    if (selectedTags.indexOf(tag) === -1) {
      //add tagg to selected tags
      setSelectedTags((current) => [...current, tag]);
      //remove added tag from suggestedTags
      if (suggestedTags.length > 0) {
        suggestedTags.map((tg, i) => {
          if (tg._id === tag) {
            setSuggestedTags((current) =>
              current.filter((item, itemIndex) => itemIndex !== i)
            );
          }
        });
      }
    }
  };

  /**
   * return string of tags base tag array
   * @param {array} tags
   * @returns
   */
  const getInputTags = (tags) => {
    let tagsName = [];
    if (tags) {
      tags.map((tag) => {
        tagsName.push(tag.name);
      });
    }
    return tagsName.join(",");
  };

  /**
   * generate new metaseo data for resource
   * @param {str} resourceId
   */
  const generateMeta = async (resourceId) => {
    await ResourceAPI.generateResourceMeta(resourceId).then((response) => {
      if (response.status) {
        const { metaTitle, metaDescription, metaKeywords } = response.data;
        setValue("meta_title", metaTitle);
        setValue("meta_description", metaDescription);
        setValue("meta_keywords", metaKeywords);
      }
      dispatch(setMessage(`${response.data}`, "success"));
    }).catch((e) => {
      dispatch(setMessage(`${e}`, "danger"));
    });
  };

  const [previewLoading, setPreviewLoading] = useState(false);
  const handlePreview = async (files) => {
    setPreviewLoading(true);
    let tempResult = [];
    let filtedFiles = [];
    if (tempPreviewRef.current) {
      filtedFiles = [...files].filter(
        (obj1) =>
          !tempPreviewRef.current.some((obj2) => obj1.name === obj2.name)
      );
      tempPreviewRef.current = [...tempPreviewRef.current, ...filtedFiles];
    } else {
      filtedFiles = [...files];
      tempPreviewRef.current = [...files];
    }

    if (filtedFiles.length) {
      await Promise.all(
        filtedFiles.map(async (file) => {
          const formData = new FormData();
          formData.append("data", file);
          const { data } = await previewProcess(formData);

          if (data) {
            tempPreviewRef.current.map((item) => {
              if (item.name === file.name) {
                item.filename = data.detail.filename;
                return item;
              } else {
                return item;
              }
            });

            // Build preview object with all metadata, including file size and converted info if present
            const newPreview = {
              filename: data.detail.filename,
              sizes: [
                {
                  size: "original",
                  path: data.detail.original.path,
                  contentType: data.detail.original.contentType,
                  width: data.detail.original.width,
                  height: data.detail.original.height,
                  file_size: data.detail.original.file_size
                }
              ]
            };
            if (data.detail.thumbnail) {
              newPreview.sizes.push({
                size: "small",
                path: data.detail.thumbnail.path,
                contentType: data.detail.thumbnail.contentType,
                width: data.detail.thumbnail.width,
                height: data.detail.thumbnail.height,
                file_size: data.detail.thumbnail.file_size
              });
            }
            if (data.detail.converted) {
              newPreview.converted = {
                path: data.detail.converted.path,
                contentType: data.detail.converted.contentType,
                width: data.detail.converted.width,
                height: data.detail.converted.height,
                file_size: data.detail.converted.file_size
              };
            }
            tempResult.push(newPreview);
          }
        })
      );
      setSelectedImage([...selectedImage, ...tempResult]);
    }
    setPreviewLoading(false);
  };

  // awsUpload is deprecated and not used; removed setProgress reference to fix error

  const handleFile = async (files) => {
    let filtedFiles = [];
    if (tempFilesRef.current) {
      filtedFiles = [...files].filter(
        (obj1) => !tempFilesRef.current.some((obj2) => obj1.name === obj2.name)
      );
      tempFilesRef.current = [...tempFilesRef.current, ...filtedFiles];
    } else {
      filtedFiles = [...files];
      tempFilesRef.current = [...files];
    }
    

    if (filtedFiles.length) {
      await Promise.all(
        filtedFiles.map(async (file) => {
          // Use fileProcess instead of awsUpload
          // fileProcess expects a raw File object, not FormData
          const response = await fileProcess(file);

          if (!response || !response.data) {
            // Show error to user or handle gracefully
            console.error("No data returned from file upload");
            return;
          }
          
          const { data } = response;

          if (data) {
            // Determine storage type and path from response
            const isB2Storage = data.storage_type === 'b2';
            const storagePath = isB2Storage ? data.b2_path : data.filepath;
            
            const fileData = {
              filename: data.filename,
              aws_path: data.aws_path || '',
              path: storagePath || data.filepath || '',
              format: data.format || file.name.split('.').pop() || '',
              file_size: data.file_size || file.size,
              storage_type: isB2Storage ? 'backblaze_b2' : 'local_server',
              b2_path: isB2Storage ? data.b2_path : null,
              uploaded_at: new Date().toISOString(),
              status: 'active'
            };
            
            setNewResourceFiles((oldArray) => [
              ...oldArray,
              fileData
            ]);
            setResourceFiles((oldArray) => [
              ...oldArray,
              fileData
            ]);
          }
        })
      );
    }
  };

  const checkLength = (text, min, max) => {
    if (text.length > min && text.length < max) {
      return `<span className="badge bg-success mx-1">${text.length}</span>`;
    } else {
      return `<span className="badge bg-warning mx-1">${text.length}</span>`;
    }
  };

  useEffect(() => {
    /**
     * get resources data by id
     * @param {str} id
     */
    async function fetchData(id) {
      setIsLoading(true);
      try {
        const { data } = await ResourceAPI.getResourceById(id);
        setResource(data);
        setSelectedImage(data.images);
        setMainImage(data.mainImage);
      } catch (error) {
        dispatch(setMessage(`${error}`, "danger"));
      }

      setIsLoading(false);
    }

    /**
     * Get file data base resource Id
     * @param {str} resourceId
     */
    // const fetchFiles = async (resourceId) => {
    async function fetchFiles(resourceId) {
      setIsLoading(true);
      await FileAPI.getResourceFiles(resourceId).then((response) => {
        setResourceFiles(response.data);
        setIsLoading(false);
      }).catch((e) => {
        setIsLoading(false);
      });
    }

    fetchData(id);
    fetchFiles(id);
  }, []);

  // check if resource is reject
  useEffect(() => {
    async function fetchRejectData(id) {
      try {
        const { data: rejection } = await ResourceAPI.getRejectionReasonById(
          id
        );
        const checkRejectionReason = RejectionReason.find(
          (item) => item.value === rejection.rejection_reason
        );
        if (checkRejectionReason)
          setValue("rejection_reason", rejection.rejection_reason);
        else {
          setValue("rejection_reason", "other");
          setValue("other_reasons", rejection.rejection_reason);
        }
      } catch (error) {
        dispatch(setMessage(`${error}`, "danger"));
      }
    }


    if (resource.status == 'reject') {
      fetchRejectData(resource._id);
    }
  }, [resource]);

  useEffect(() => {
    if (resource.name) {
      setValue("name", resource.name);
    }
    if (resource.slug) {
      setValue("slug", resource.slug);
    }
    if (resource.creator) {
      setValue("created_by", resource.creator.email);
    }
    if (resource.tags) {
      setValue("tags", getInputTags(resource.tags));
      let rtags = getInputTags(resource.tags);
      setSelectedTags(rtags.split(","));
    }

    if (resource.description) {
      setValue("description", resource.description);
      setDescriptionValue(resource.description);
    }
    if (resource.status) {
      setValue("status", resource.status);
    }
    if (resource.license) {
      setValue("license", resource.license);
    }

    if (resource.price) {
      setValue("price", resource.price);
    }

    if (resource.scheduled_at) {
      // Format schedule_at to datetime-local format (YYYY-MM-DDTHH:MM)
      // Handle the datetime string directly to avoid timezone conversion issues
      let formattedDate = resource.scheduled_at;
      
      // If the datetime includes microseconds, remove them
      if (formattedDate.includes('.')) {
        formattedDate = formattedDate.split('.')[0];
      }
      
      // Ensure it's in the correct format for datetime-local (YYYY-MM-DDTHH:MM)
      if (formattedDate.length > 16) {
        formattedDate = formattedDate.slice(0, 16);
      }
      
      setValue("scheduled_at", formattedDate);
    }

    if (resource.metaSeo && resource.metaSeo.metaTitle) {
      setValue("meta_title", resource.metaSeo.metaTitle);
    }
    if (resource.metaSeo && resource.metaSeo.metaDescription) {
      setValue("meta_description", resource.metaSeo.metaDescription);
    }
    if (resource.metaSeo && resource.metaSeo.metaKeywords) {
      setValue("meta_keywords", resource.metaSeo.metaKeywords);
    }
    if (resource.metaSeo && resource.metaSeo.canonicalURL) {
      setValue("meta_canonicalURL", resource.metaSeo.canonicalURL);
    }
    if (resource.metaSeo && resource.metaSeo.redirectURL) {
      setValue("meta_redirectURL", resource.metaSeo.redirectURL);
    }
    if (typeof resource.is_picked === "boolean") {
      setValue("is_picked", resource.is_picked);
    } else if (resource.is_picked !== undefined) {
      setValue("is_picked", Boolean(resource.is_picked));
    }
  }, [resource]);

  useEffect(() => {
    if (watch("status") === "reject") {
      const rejection_reason = getValues("rejection_reason");
      if (rejection_reason) {
        setValue("rejection_reason", rejection_reason);
      } else {
        setValue("rejection_reason", RejectionReason[0].value);
      }
    }
  }, [watch("status")]);

  // set focus to textarea when selected other reasons
  useEffect(() => {
    if (watch("rejection_reason") === "other") {
      setFocus("other_reasons");
    }
  }, [watch("rejection_reason"), setFocus]);

  const removePreview = (index) => {
    const removedPreviews = selectedImage.filter((_, i) => i !== index);
    setSelectedImage(removedPreviews);
    if (index < mainImage) {
      setMainImage((prev) => prev - 1);
    }
  };

  // Watch license and price fields
  const license = watch("license");
  const price = watch("price");

  // Ensure price is always a valid number for backend
  useEffect(() => {
    if (license !== "premium") {
      setValue("price", 0);
    }
  }, [license, setValue]);

  return (
    <AuthLayout>
      {isLoading ? (
        <>
          <p>loading</p>
        </>
      ) : (
        <>
          <header
            className={"d-flex justify-content-between align-items-center mb-4"}
          >
            <div className="d-flex align-items-center">
              <h2 className="mb-0 me-2 fs-5">{"Edit"}</h2>
              <small className="rounded-pill bg-secondary bg-opacity-10 text-secondary fw-normal px-2">
                {resource.slug?.split("-").pop()}
                {/* hidden value */}
                <input
                  className="form-control"
                  type="hidden"
                  {...register("slug_id")}
                  value={resource.slug?.split("-").pop()}
                />
              </small>
            </div>
            <div className="">
              <a
                className="btn btn-secondary me-2"
                href={`/resources/view/${resource._id}`}
              >
                {"View"}
              </a>
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={history.back}
              >
                {"Back"}
              </button>
            </div>
          </header>
          {message && (
            <div className="mb-4">
              <div className={`alert alert-${messageType}`} role="alert">
                {message}
              </div>
            </div>
          )}
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row pb-8 gx-5">
              <div className="col-md-7">
                <div className="mb-3">
                  <label htmlFor="name" className="form-label">
                    Resource name
                  </label>
                  <input className="form-control" {...register("name")} />
                  {errors.name && (
                    <span className="small text-danger">
                      This field is required
                    </span>
                  )}
                </div>
                <div className="mb-3">
                  <label htmlFor="slug" className="form-label">
                    Resource slug
                  </label>
                  <div className="d-flex">
                    <input className="form-control" {...register("slug")} />
                    <div>
                      <button
                        className="btn btn-link"
                        onClick={(event) => {
                          slugify(event);
                        }}
                      >
                        <i className="bi bi-check text-success fs-6"></i>
                      </button>
                    </div>
                  </div>
                  {errors.slug && (
                    <span className="small text-danger">
                      This field is required
                    </span>
                  )}
                </div>
                <div className="mb-3">
                  <label htmlFor="description" className="form-label">
                    Description
                  </label>
                  <TiptapEditor value={descriptionValue} onChange={setDescriptionValue} />
                  {errors.description && (
                    <span className="small text-danger">
                      This field is required
                    </span>
                  )}
                </div>
                <div className="row">
                  <div className="col-md-2 mb-3">
                    <label htmlFor="tags" className="form-label">
                      License
                    </label>
                    <select
                      className="form-select"
                      defaultValue={"free"}
                      {...register("license")}
                    >
                      <option value="free">Free</option>
                      <option value="premium">Premium</option>
                    </select>
                  </div>
                  <div className="col-md-2 mb-3">
                    <label htmlFor="price" className="form-label">
                      Price
                    </label>
                    <input
                      id="price"
                      type="number"
                      min="0"
                      step="0.01"
                      className="form-control"
                      placeholder="Enter price"
                      {...register("price")}
                      disabled={license !== "premium"}
                      value={license === "premium" ? price : 0}
                      onChange={e => setValue("price", e.target.value)}
                    />
                  </div>
                  <div className="col-md-2 mb-3">
                    <label htmlFor="status" className="form-label">
                      Status
                    </label>
                    <select className="form-select" {...register("status")}> 
                      <option value="draft">Draft</option>
                      <option value="reject">Reject</option>
                      <option value="schedule">Schedule</option>
                      <option value="pending">Pending</option>
                      <option value="missing">Missing</option>
                      <option value="active">Active</option>
                      <option value="deleted">Deleted</option>
                    </select>
                  </div>
                  {watch("status") === "schedule" && (
                    <div className="col-md-6 mb-3">
                      <label htmlFor="scheduled_at" className="form-label">
                        Schedule date
                      </label>
                      <input
                        id="scheduled_at"
                        type="datetime-local"
                        className="form-control"
                        placeholder="Enter scheduled date and time"
                        {...register("scheduled_at")}
                      />
                    </div>
                  )}
                  {watch("status") === "reject" && (
                  <div className="col-md-6 mb-3">
                    <label htmlFor="rejection_reason" className="form-label">
                      Rejection reason
                    </label>
                    <select
                      disabled={watch("status") !== "reject"}
                      id="rejection_reason"
                      className="form-select"
                      {...register("rejection_reason", { required: false })}
                    >
                      {RejectionReason.map((item, index) => (
                        <option value={item.value} key={index}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  )}
                  {watch("rejection_reason") === "other" &&
                    watch("status") === "reject" && (
                      <div className="col-md-12">
                        <textarea
                          disabled={
                            watch("rejection_reason") !== "other" ||
                            watch("status") !== "reject"
                          }
                          placeholder="Enter other reasons here..."
                          className="form-control"
                          {...register("other_reasons", {
                            required: "Other reason cannot be left blank",
                            onBlur: () => {
                            }
                          })}
                          rows={4}
                        />
                        {errors.other_reasons && (
                          <p role="alert" className="text-danger">
                            {errors.other_reasons.message}
                          </p>
                        )}
                      </div>
                    )}

                  <div className="col-md-4 my-4">
                    <div className="form-check form-switch py-2">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="is_picked"
                        role="switch"
                        value=""
                        {...register("is_picked")}
                      />
                      <label className="form-check-label" htmlFor="is_picked">
                        Picked
                      </label>
                    </div>
                  </div>

                  <div className="col-md-12 mb-4">
                    <label htmlFor="new_date" className="form-label sr-only">
                      Created at
                    </label>
                    <input
                      id="new_date"
                      type={"date"}
                      className="form-control"
                      defaultValue={""}
                      placeholder={"Enter new date"}
                      {...register("new_date")}
                    />
                  </div>

                  
                </div>
                {/* row */}
                <ResourceTags
                  selectedTags={selectedTags}
                  handleTags={handleTags}
                  handleRemoveTag={handleRemoveTag}
                  suggestedTags={suggestedTags}
                  addSugggestTag={addSugggestTag}
                  register={register}
                />
                <div
                  className="mt-5 mb-4"
                  style={{
                    width: `100%`,
                    height: `1px`,
                    background: `#ebebeb`
                  }}
                />
                <ResourceMetaSEO
                  showMeta={showMeta}
                  toggleShowMeta={toggleShowMeta}
                  generateMeta={generateMeta}
                  resource={resource}
                  register={register}
                  watchTitle={watchTitle}
                  watchDescription={watchDescription}
                  checkLength={checkLength}
                />
              </div>
              {/* col */}
              <div className="col-md-5">
                <div className="mb-4">
                  <div>Preview images</div>
                  <div style={{ position: 'relative' }}>
                    <ResourceFileUpload
                      label="Preview file"
                      onDrop={handlePreview}
                      accept={{
                        "image/png": [".png"],
                        "image/jpeg": [".jpg", ".jpeg"]
                      }}
                      error={previewUploadError}
                      progress={previewProgress}
                    />
                    {previewProgress > 0 && previewProgress < 100 && (
                      <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center" style={{background: 'rgba(255,255,255,0.7)', zIndex: 10}}>
                        <div className="spinner-border text-primary" role="status" style={{width: '2.5rem', height: '2.5rem'}}>
                          <span className="visually-hidden">Uploading...</span>
                        </div>
                      </div>
                    )}
                  </div>
                  {selectedImage.length > 0 && (
                    <div className="d-flex flex-wrap gap-3 bg-gray">
                      {selectedImage.map((preview, index) => {
                        const isMain = mainImage === index;
                        return (
                          <div
                            className="text-center position-relative"
                            key={index}
                            style={{ minWidth: 160, maxWidth: 220, flex: '1 0 180px' }}
                          >
                            <div
                              className="shadow position-relative mx-auto"
                              style={{ width: 200, height: 140, display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fff' }}
                            >
                              <img
                                src={`${MEDIA_URL}${preview.sizes && preview.sizes[1] ? preview.sizes[1].path : preview.sizes[0].path}`}
                                alt={`Preview ${index}`}
                                style={{
                                  width: '100%',
                                  height: '100%',
                                  objectFit: 'contain',
                                  borderRadius: 10,
                                  border: isMain ? '1.5px solid #222' : '',
                                  background: '#f8f9fa',
                                  transition: 'border 0.2s',
                                }}
                              />
                              {/* Remove button always visible */}
                              <button
                                className="position-absolute top-0 end-0 border-0 bg-transparent"
                                type="button"
                                onClick={() => removePreview(index)}
                                title="Remove image"
                                style={{ zIndex: 2 }}
                              >
                                <i className="bi bi-x-circle-fill"></i>
                              </button>
                            </div>
                            {/* Preview sizes info */}
                            <div className="mt-2 small text-muted text-start px-2">
                              {preview.sizes && preview.sizes[0] && (
                                <div>
                                  {preview.sizes[0].width}x{preview.sizes[0].height}px, {preview.sizes[0].contentType}
                                </div>
                              )}
                              {preview.sizes && preview.sizes[1] && (
                                <div>
                                  {preview.sizes[1].width}x{preview.sizes[1].height}px, {preview.sizes[1].contentType}
                                </div>
                              )}
                            </div>
                            {/* Main image radio if more than 1 image */}
                            {selectedImage.length > 1 && (
                              <div className="form-check mt-2 d-flex justify-content-center align-items-center gap-2">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="mainImageRadio"
                                  id={`mainImageRadio${index}`}
                                  checked={isMain}
                                  onChange={() => setMainImage(index)}
                                />
                                <label className="form-check-label" htmlFor={`mainImageRadio${index}`}>
                                  {isMain ? "Cover Image" : "Set as cover"}
                                </label>
                              </div>
                            )}
                            {/* If only one image, show cover label */}
                            {selectedImage.length === 1 && isMain && (
                              <p className="pt-2 fw-semibold">Cover Image</p>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
                <div>Resource files</div>  
                <ResourceFileUpload
                  label="Resource files"
                  onDrop={handleFile}
                  accept={{
                    "application/postscript": [".ai", ".eps"],
                    "image/svg+xml": [".svg"],
                    "application/pdf": [".pdf"],
                    "image/jpeg": [".jpg", ".jpeg"],
                    "image/png": [".png"],
                    "image/gif": [".gif"],
                    "image/webp": [".webp"],
                    "image/bmp": [".bmp"],
                    "image/tiff": [".tif", ".tiff"],
                  }}
                  error={fileUploadError}
                  progress={fileUploading}
                />
                <div className="mt-4">
                  {resourceFiles && (
                    <ResourceFiles resourceFiles={resourceFiles}/>
                  )}
                </div>
              </div>
              {/* col */}
            </div>
            {/* row */}
            <input
              className="form-control"
              type={"hidden"}
              {...register("created_by")}
            />
            <div className="position-sticky bottom-0 bg-white border-t-1 py-3">
            <button
              type="submit"
              disabled={isLoading}
              className="btn btn-primary"
            >
              Submit
            </button>
            </div>
          </form>
        </>
      )}
    </AuthLayout>
  );
}

function mapStateToProps(state) {
  const { token } = state.auth;
  const { user } = state.user;
  const { message, messageType } = state.message;
  return {
    token,
    user,
    message,
    messageType
  };
}

export default connect(mapStateToProps)(ResourceEdit);
